import * as React from 'react'
import OutlinedInput from '@mui/material/OutlinedInput'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import Box from '@mui/material/Box'
import { handleFilterIcon } from '../../utils'
import { TFilterTypes } from '../../types'
import { IconButton, Typography, useTheme } from '@mui/material'
import { FilterTypeMap, Reset } from '../../constants'
import SearchIcon from '@mui/icons-material/Search'

interface Props {
  options: unknown[]
  value: TFilterTypes | ''
  onChange(value: TFilterTypes): void
}

const MENU_WIDTH = 250
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 320,
      width: MENU_WIDTH,
    },
  },
}

const visuallyHiddenStyles = {
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: '1px',
  overflow: 'hidden',
  position: 'absolute',
  whiteSpace: 'nowrap',
  width: `${MENU_WIDTH}px`,
}

export function FilterDropDown({ value, options, onChange }: Props) {
  const [open, setOpen] = React.useState(false)
  const theme = useTheme()

  const handleClose = () => {
    setOpen(false)
  }

  const handleOpen = (e) => {
    e?.preventDefault()
    e?.stopPropagation()
    setOpen(true)
  }

  const handleChange = (event: SelectChangeEvent<TFilterTypes>) => {
    const {
      target: { value },
    } = event

    onChange(value as TFilterTypes)
  }

  return (
    <Box>
      <IconButton
        id="filter-dropdown-drigger"
        onClick={handleOpen}
        sx={{
          width: 30,
          height: 50,
          borderRadius: '10px',
          p: 0,
          backgroundColor: theme.palette.customGrey.three,
        }}
      >
        {!value ? <SearchIcon /> : handleFilterIcon(value)}
      </IconButton>
      <FormControl>
        <Select
          labelId="filter-dropdown-select"
          id="filter-dropdown-select"
          open={open}
          value={value || ''}
          onClose={handleClose}
          onOpen={handleOpen}
          onChange={handleChange}
          input={
            <OutlinedInput sx={{ border: '2px solid red' }} label="Name" />
          }
          MenuProps={MenuProps}
          sx={visuallyHiddenStyles}
        >
          {[...options]?.map((name: TFilterTypes) => {
            return (
              <MenuItem key={name} value={name === Reset ? Reset : name}>
                {handleFilterIcon(name)}
                <Typography sx={{ ml: '10px' }}>
                  {FilterTypeMap[name]}
                </Typography>
              </MenuItem>
            )
          })}
        </Select>
      </FormControl>
    </Box>
  )
}
